module.exports = __webpack_public_path__ + "static/media/spectrum.e9b2bb04.avif";